import { render, staticRenderFns } from "./SearchUserComponent.vue?vue&type=template&id=42470955&"
import script from "./SearchUserComponent.vue?vue&type=script&lang=js&"
export * from "./SearchUserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports